const playStoreUrl =
  "https://play.google.com/store/apps/details?id=com.ahis.patientapp";
const appStoreUrl = "https://apps.apple.com/us/app/ahis/id6765457653";

interface AppStoreButtonsProps {
  className?: string;
}

export default function AppStoreButtons({ className = "" }: AppStoreButtonsProps) {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <a
        href={playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get AHIS Patient App on Google Play"
        className="flex items-center gap-2.5 px-5 py-2.5 rounded-xl bg-gray-900 dark:bg-black text-white hover:bg-gray-800 dark:hover:bg-gray-900 transition-colors whitespace-nowrap"
      >
        <i className="ri-google-play-fill text-2xl" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] text-gray-300">GET IT ON</span>
          <span className="block text-sm font-semibold">Google Play</span>
        </span>
      </a>
      <a
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download AHIS Patient App on the App Store"
        className="flex items-center gap-2.5 px-5 py-2.5 rounded-xl bg-gray-900 dark:bg-black text-white hover:bg-gray-800 dark:hover:bg-gray-900 transition-colors whitespace-nowrap"
      >
        <i className="ri-apple-fill text-2xl" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] text-gray-300">
            Download on the
          </span>
          <span className="block text-sm font-semibold">App Store</span>
        </span>
      </a>
    </div>
  );
}
